<template>
  <div class="app-container">


    <PageHeader title="采购计划" icon="el-icon-shopping-cart-2" />

    <!-- 搜索栏 -->
    <div class="filter-container">
      <el-input v-model="listQuery.planNo" placeholder="计划编号" style="width: 200px; margin-right: 10px;"
        class="filter-item" @keyup.enter.native="handleFilter" />
      <el-select v-model="listQuery.status" placeholder="状态" clearable style="width: 120px; margin-right: 10px;"
        class="filter-item">
        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        搜索
      </el-button>
      <el-button class="filter-item" type="primary" icon="el-icon-plus" @click="handleCreate">
        新建计划
      </el-button>
    </div>

    <!-- 数据表格 -->
    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row
      style="margin: 20px 0;">
      <!-- <el-table-column label="计划编号" prop="planNo" align="center" /> -->
      <el-table-column label="计划名称" prop="planName" align="center" />
      <el-table-column label="部门" align="center" prop="departmentPath" />
      <el-table-column label="分类" prop="categoryLabel" align="center" />
      <el-table-column label="工作流" align="center">
        <template slot-scope="{row}">
          <el-tag size="medium" :type="row.status === 1 ? 'success' : 'info'" style="cursor: pointer"
            @click="handleShowFlow(row)">
            {{ row.workFlowName }}
            <i class="el-icon-arrow-right el-icon--right"></i>
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="{row}">
          <el-tag :type="getStatusType(row.status)">
            {{ getStatusText(row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" align="center">
          <template slot-scope="scope">
            {{ scope.row.createTime ? new Date(scope.row.createTime).toLocaleString() : '' }}
          </template>
        </el-table-column>
      <el-table-column label="审核时间" align="center" width="160">
        <template slot-scope="{row}">
          {{ formatDateTime(row.approveTime || row.approved_time || row.gmtApprove) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-dropdown trigger="hover" @command="handleCommand($event, scope.row)">
            <el-button type="primary" size="mini">
              处理
                <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- 编辑按钮 -->
              <el-dropdown-item v-if="scope.row.status === 1" command="edit">
                <i class="el-icon-edit"></i> 编辑
              </el-dropdown-item>
              <!-- 明细按钮 -->
              <el-dropdown-item command="detail">
                <i class="el-icon-document"></i> 明细
              </el-dropdown-item>
              <!-- 提交审核按钮 -->
              <el-dropdown-item v-if="scope.row.status === 1" command="submit">
                <i class="el-icon-check"></i> 提交审核
              </el-dropdown-item>
              <!-- 审核按钮 -->
              <el-dropdown-item v-if="scope.row.status === 2 || scope.row.status === 3" command="approve">
                <i class="el-icon-view"></i> 审核
              </el-dropdown-item>
              <!-- 取消按钮 -->
              <el-dropdown-item v-if="scope.row.status === 1" command="cancel">
                <i class="el-icon-close"></i> 取消
              </el-dropdown-item>
              <!-- 删除按钮 -->
              <el-dropdown-item v-if="[1, 5].includes(scope.row.status)" command="delete">
                <i class="el-icon-delete"></i> 删除
              </el-dropdown-item>
              <!-- 采购下单按钮 -->
              <el-dropdown-item v-if="scope.row.status === 4" command="createOrder">
                <i class="el-icon-shopping-cart-2"></i> 采购下单
              </el-dropdown-item>
              <!-- 重新提交按钮 -->
              <el-dropdown-item v-if="scope.row.status === 5" command="resubmit">
                <i class="el-icon-refresh"></i> 重新提交
              </el-dropdown-item>
              <!-- 撤销按钮 -->
              <el-dropdown-item v-if="scope.row.status === 2" command="revoke">
                <i class="el-icon-back"></i> 撤销
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size"
      style="padding: 20px 0;" @pagination="getList" />

    <!-- 创建订单组件 -->
    <!-- <create-order :visible.sync="createOrderVisible" :plan-data="selectedPlan" @submit="handleOrderSubmit" /> -->
    <!-- 在template中添加采购订单弹窗 -->
    <el-dialog title="生成采购订单" :visible.sync="orderDialogVisible" width="500px">
      <el-form ref="orderForm" :model="orderForm" label-width="100px">
        <el-form-item label="订单名称" prop="orderName">
          <el-input v-model="orderForm.orderName" placeholder="请输入采购订单名称" />
        </el-form-item>
        <el-form-item label="工作流" prop="workProcessID">
          <el-select v-model="orderForm.workProcessID" placeholder="请选择工作流" style="width: 100%">
            <el-option v-for="item in workFlowOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="供应商" prop="supplierId">
          <el-select 
            v-model="orderForm.supplierId" 
            placeholder="请选择供应商" 
            style="width: 100%"
            filterable
            clearable
            @focus="fetchSuppliers"
          >
            <el-option 
              v-for="item in supplierOptions" 
              :key="item.SupplierID" 
              :label="`${item.SupplierName}(${item.ChargeTel})`" 
              :value="item.SupplierID"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="orderDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOrderSubmit">确定</el-button>
      </div>
    </el-dialog>


    <!-- 流程对话框 -->
    <el-dialog title="审批流程" :visible.sync="flowDialogVisible" width="700px" class="flow-dialog">
      <div v-loading="flowLoading">
        <el-timeline>
          <el-timeline-item v-for="(flow, index) in flowList" :key="index" :type="getTimelineNodeType(flow.status)"
            size="large">
            <div class="flow-item">
              <!-- 节点标题和状态 -->
              <div class="flow-header">
                <span class="flow-title">
                  <span class="step-tag">步骤 {{ flow.step }}</span>
                  {{ flow.title }}
                </span>
                <el-tag size="mini" :type="getStatusTagType(flow.status)">
                  {{ flow.statusText }}
                </el-tag>
              </div>

              <!-- 审批人信息 -->
              <div class="flow-content">
                <div class="flow-info">
                  <div class="info-header">
                    <i class="el-icon-user"></i>
                    <span>审批人</span>
                  </div>
                  <div class="approver-list">
                    <template v-if="flow.approverDetails && flow.approverDetails.length">
                      <div v-for="(approver, idx) in flow.approverDetails" :key="idx" class="approver-item">
                        <!-- 审批人基本信息 -->
                        <div class="approver-row">
                          <span class="approver-name">{{ approver.name }}</span>
                          <!-- 修改审批人状态显示部分 -->
                          <!-- <el-tag size="mini" :type="getStatusTagType(approver.status)"
                            :style="{ color: approver.status === 0 ? '#f56c6c' : '' }">
                            {{ approver.status }}
                          </el-tag> -->
                          <el-tag size="mini" :type="getStatusTagType(approver.status)"
                            :class="{ 'pending-status': approver.status === 0 }">
                            {{ getApproverStatusText(approver.status) }}
                          </el-tag>
                          <span class="approve-time">
                            {{ approver.time ? formatDateTime(approver.time) : '' }}
                          </span>
                        </div>

                        <!-- 审批意见 -->
                        <div v-if="approver.comment" class="approve-comment">
                          <span class="comment-label" style="padding-left: 1px;">审核意见：</span>
                          <span class="comment-text">{{ approver.comment }}</span>
                        </div>
                      </div>
                    </template>
                    <span v-else class="no-approver">待处理</span>
                  </div>
                </div>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>

    <!-- 在 template 中添加创建/编辑计划的对话框 -->
    <!-- 在 el-dialog 流程对话框之前添加 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="650px">
      <el-form ref="dataForm" :model="temp" :rules="rules" label-position="right" label-width="100px">
        <el-form-item label="计划名称" prop="planName">
          <el-input v-model="temp.planName" placeholder="请输入计划名称" />
        </el-form-item>

        <el-form-item label="工作流" prop="workFlowId">
          <el-select v-model="temp.workFlowId" placeholder="请选择工作流" style="width: 100%" clearable>
            <el-option v-for="item in workFlowOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="部门" prop="department">
          <el-cascader v-model="temp.departmentPath" :options="departmentList" :props="{
            checkStrictly: true,
            emitPath: true
          }" clearable style="width: 100%" placeholder="请选择部门" @change="handleDepartmentChange" />
        </el-form-item>

        <el-form-item label="分类" prop="category">
          <el-select v-model="temp.category" placeholder="请选择分类" style="width: 100%" clearable>
            <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="优先级" prop="priority">
          <el-rate v-model="temp.priority" :max="3" :texts="['低', '中', '高']" show-text />
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="temp.remark" type="textarea" :rows="3" placeholder="请输入备注信息" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogStatus === 'create' ? createData() : updateData()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPurchasePlanList, createPurchasePlan, updatePurchasePlan, deletePurchasePlan } from '@/api/purchase'
import request from '@/utils/request'
import Pagination from '@/components/Pagination'
import CreateOrder from '../order/components/CreateOrder.vue'
import PageHeader from '@/components/common/PageHeader.vue'
import moment from 'moment'

export default {
  name: 'PurchasePlan',
  components: { Pagination, CreateOrder, PageHeader },
  data() {
    return {
      departmentList: [],
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        status: -1,
        keyword: '',
        department: '',
        category: '',


      },
      orderDialogVisible: false,
      orderForm: {
        planID: '',
        orderName: '',
        workProcessID: ''
      },
      statusOptions: [
        { label: '全部', value: -1 },
        { label: '草稿', value: 1 },
        { label: '待审核', value: 2 },
        { label: '审核中', value: 3 },
        { label: '已通过', value: 4 },
        { label: '已拒绝', value: 5 },
        { label: '已取消', value: 6 }
      ],
      temp: {
        planId: undefined,
        planName: '',
        planNo: '',
        status: 1,
        remark: '',
        workFlowId: '',
        negotiatedAmount: 0,
        department: '',
        departmentPath: [],
        category: '',
        priority: 1
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑计划',
        create: '新建计划'
      },
      rules: {
        planName: [{ required: true, message: '计划名称不能为空', trigger: 'blur' }],
        workFlowId: [{ required: true, message: '请选择工作流', trigger: 'change' }],
        department: [{ required: true, message: '请选择部门', trigger: 'change' }],
        category: [{ required: true, message: '请选择分类', trigger: 'change' }]
      },
      createOrderVisible: false,
      selectedPlan: null,
      flowDialogVisible: false,
      flowList: [],
      flowLoading: false,
      workFlowOptions: [],
      orderWorkFlowOptions: [],
      departmentOptions: [],
      categoryOptions: [],
      supplierOptions: [],
      isSupplierLoading: false
    }
  },
  created() {
    // 先获取所有选项数据，再获取列表
    Promise.all([
      this.getWorkFlowOptions(),
      this.getOrderWorkFlowOptions(),
      this.fetchDepartmentList(),
      this.getCategoryOptions()
    ]).then(() => {
      this.getList()
    })
  },
  methods: {
    // 获取供应商列表
    async fetchSuppliers() {
      if (this.supplierOptions.length > 0) return // 如果已经加载过就不再重复加载
      
      this.isSupplierLoading = true
      try {
        const response = await request({
          url: '/api/v1/purchasing-plan/suppliers',
          method: 'POST',
          data: {
            planId: this.orderForm.planID
          }
        })
        
        if (response.data) {
          this.supplierOptions = response.data.map(item => ({
            ...item,
            label: `${item.SupplierName}(${item.ChargeTel})`,
            value: item.SupplierID
          }))
        }
      } catch (error) {
        console.error('获取供应商列表失败:', error)
        this.$message.error('获取供应商列表失败')
      } finally {
        this.isSupplierLoading = false
      }
    },
    
    // 打开采购订单弹窗时调用
    handleCreateOrder(row) {
      this.orderForm = {
        planID: row.planId,
        orderName: row.planName,
        workProcessID: '',
        supplierId: '' // 清空供应商选择
      }
      this.supplierOptions = [] // 清空供应商选项
      this.orderDialogVisible = true
    },
    // 提交采购订单
    async handleCreateOrderSubmit() {
    try {
      // 添加二次确认
      await this.$confirm('确定要生成采购订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      
      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: '正在生成采购订单...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      const res = await request({
        url: '/api/v1/purchasing-order/create-from-plan',
        method: 'POST',
        data: {
          
          "plan_id":this.orderForm.planID,
          "order_name":this.orderForm.orderName,
          "work_flow_id":this.orderForm.workProcessID,
         "supplier_ids":[this.orderForm.supplierId]
             }
      })
      
      loading.close()
      
      if (res.status === 1) {
        this.$message.success('采购订单创建成功')
        this.orderDialogVisible = false
        // 刷新列表或其他操作
      } else {
        this.$message.error(res.msg || '创建采购订单失败')
      }
    } catch (error) {
      // 如果用户点击取消,不显示错误信息
      if (error !== 'cancel') {
        console.error('创建采购订单失败:', error)
        this.$message.error('创建采购订单失败')
      }
    }
  },
    // async handleCreateOrderSubmit() {
    //   try {
    //     const res = await request({
    //       url: '/api/v1/purchasing-order/save',
    //       method: 'POST',
    //       data: this.orderForm
    //     })

    //     if (res.status === 1) {
    //       this.$message.success('采购订单创建成功')
    //       this.orderDialogVisible = false
    //       // 刷新列表或其他操作
    //     } else {
    //       this.$message.error(res.msg || '创建采购订单失败')
    //     }
    //   } catch (error) {
    //     console.error('创建采购订单失败:', error)
    //     this.$message.error('创建采购订单失败')
    //   }
    // },
    // 获取计划列表
    getList() {
      this.listLoading = true
      getPurchasePlanList(this.listQuery).then(response => {
        if (response.list) {
          // 添加调试日志
          console.log('原始数据:', response.list)
          
          this.list = response.list.map(item => ({
            ...item,
            // 确保字段名称匹配，根据后端实际返回的字段名进行映射
            createTime: item.createdAt|| item.created_time || item.gmtCreate,
            approveTime: item.approveTime || item.approved_time || item.gmtApprove,
            // 其他字段保持不变
            category: item.category,
            categoryLabel: item.categoryLabel,
            workFlowId: item.workFlowId,
            workFlowName: item.workFlowName,
            departmentPath: item.departmentPath
          }))
          
          // 添加处理后的数据日志
          console.log('处理后的数据:', this.list)
          
          this.total = response.total
        } else {
          this.list = []
          this.total = 0
          this.$message.warning('暂无数据')
        }
        this.listLoading = false
      }).catch(error => {
        console.error('获取数据失败:', error)
        this.list = []
        this.total = 0
        this.listLoading = false
        this.$message.error(error.message || '获取数据失败')
      })
    },
    getStatusType(status) {
      const statusMap = {
        0: 'info',    // 未开始
        1: 'info',    // 草稿
        2: 'warning', // 待审核
        3: 'warning', // 审批中
        4: 'success', // 已通过
        5: 'danger',  // 已拒绝
        6: 'info'     // 已取消
      }
      return statusMap[status] || 'info'
    },
    getStatusText(status) {
      const statusMap = {
        1: '草稿',
        2: '待审核',
        3: '审核中',
        4: '已通过',
        5: '已拒绝',
        6: '已取消'
      }
      return statusMap[status] || '未知状态'
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    resetTemp() {
      this.temp = {
        planId: undefined,
        planName: '',
        planNo: '',
        status: 1,
        remark: '',
        workFlowId: '',
        negotiatedAmount: 0,
        department: '',
        departmentPath: [],
        category: '',
        priority: 1
      }
    },
    handleCreate() {
      this.resetTemp()
      // 确保在打开新增对话框前已经获取了所有选项数据
      Promise.all([
        this.getWorkFlowOptions(),
        this.fetchDepartmentList(),
        this.getCategoryOptions()
      ]).then(() => {
        this.dialogStatus = 'create'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          if (this.$refs.dataForm) {
            this.$refs.dataForm.clearValidate()
          }
        })
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          createPurchasePlan(this.temp).then(() => {
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        }
      })
    },
    handleUpdate(row) {
      console.log('编辑行数据:', row)
      // 创建一个新对象，避免直接修改 row
      this.temp = {
        ...row,
        workFlowId: row.processId || row.workFlowId,
        // 修改部门路径的处理逻辑
        departmentPath: row.departmentPath ? row.departmentPath.split('/').map(dept => {
          // 在部门列表中查找对应的部门ID
          const findDepartment = (list) => {
            for (const item of list) {
              if (item.label === dept) {
                return item.value
              }
              if (item.children && item.children.length) {
                const found = findDepartment(item.children)
                if (found) return found
              }
            }
            return null
          }
          return findDepartment(this.departmentList)
        }).filter(Boolean) : [], // 过滤掉可能的空值
        category: row.category,
        priority: row.priority || 1
      }

      // 如果工作流选项中没有当前工作流，添加进去
      if (row.processId && row.workFlowName && !this.workFlowOptions.some(opt => opt.value === row.processId)) {
        this.workFlowOptions.push({
          value: row.processId,
          label: row.workFlowName
        })
      }

      // 如果分类选项中没有当前分类，添加进去
      if (row.category && row.categoryLabel && !this.categoryOptions.some(opt => opt.value === row.category)) {
        this.categoryOptions.push({
          value: row.category,
          label: row.categoryLabel
        })
      }

      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate()
        }
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          updatePurchasePlan(tempData).then(() => {
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该计划?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await request({
            url: '/api/v1/purchasing-plan/delete',
            method: 'POST',
            data: {
              planId: row.planId
            }
          })

          if (response.status === 1) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            // 刷新列表
            await this.getList()
          } else {
            this.$message.error(response.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      })
    },
    handleDetail(row) {
      this.$router.push(`/purchase/plan/detail/${row.planId}`)
    },
    handleOrderSubmit(formData) {
      console.log('订单已创建:', formData)
      this.$message.success('采购订单创建成功')
    },
    // 获取时间线节点类型
    async handleShowFlow(row) {
      this.flowLoading = true
      this.flowDialogVisible = true

      try {
        // 检查是否有工作流数据
        if (row.workflow?.nodes && row.workflow.nodes.length > 0) {
          this.flowList = row.workflow.nodes.map(node => {
            return {
              title: `${node.nodeName} ${this.getNodeTypeText(node.nodeType)}`,  // 节点名称和类型
              step: node.step,       // 节点步骤
              status: node.status,   // 节点状态
              statusText: this.getNodeStatusText(node.status),//节点
              nodeType: node.nodeType,//节点类型
              isActive: node.isActive,//是否激活
              isCompleted: node.isCompleted,//是否完成
              // 处理审批人数组
              approverDetails: node.approvers?.map(approver => ({
                name: approver.approverName,//审批人名称
                status: Number(approver.status),//审批人状态
                time: approver.approveTime,//审批时间
                comment: approver.remark || ''//审批意见
              })) || []
            }
          })
        } else {
          this.flowList = [{
            title: '暂无流程数据',
            step: 1,
            status: 0,
            statusText: '未开始',
            approverDetails: []
          }]
        }
      } catch (error) {
        console.error('处理流程数据失败:', error)
        this.$message.error('处理流程数据失败')
      } finally {
        this.flowLoading = false
      }
    },
    getNodeTypeText(nodeType) {
      const typeMap = {
        1: '(串行审批)',
        2: '(并行与)',
        3: '(并行或)'
      }
      return typeMap[nodeType] || ''
    },
    getNodeStatus(status) {
      if (status === 2) return 1 // 已完成
      if (status === 1) return 2 // 进行中
      return 0 // 未开始
    },
    
    getNodeStatusText(status) {
      const statusMap = {
        0: '未开始',
        1: '进行中',
        2: '已完成',
        3: '已拒绝',
        4: '已取消'
      }
      return statusMap[status] || '未知状态'
    },
    formatDate(timestamp) {
      return moment(timestamp).format('YYYY-MM-DD HH:mm')
      // if (!timestamp) return ''
      // const date = new Date(timestamp)
      // const year = date.getFullYear()
      // const month = (date.getMonth() + 1).toString().padStart(2, '0')
      // const day = date.getDate().toString().padStart(2, '0')
      // const hour = date.getHours().toString().padStart(2, '0')
      // const minute = date.getMinutes().toString().padStart(2, '0')
      // const second = date.getSeconds().toString().padStart(2, '0')
      // return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    //获取采购订单审批流程
    async getOrderWorkFlowOptions() {
      try {
        const response = await request({
          url: '/api/v1/process/by-type',
          method: 'POST',
          data: {
            code: '100004'  // 采购计划审批流程的 code
          }
        }) 
        if (response.data) {
          this.orderWorkFlowOptions = response.data.map(item => ({
            value: item.processId,
            label: item.processName
          }))
        }
      } catch (error) {
        console.error('获取采购订单审批流程数据失败:', error)
        this.$message.error('获取采购订单审批流程数据失败')
        this.orderWorkFlowOptions = []
      }
    },
    //获取采购计划审批流程
    async getWorkFlowOptions() {
      try {
        const response = await request({
          url: '/api/v1/process/by-type',
          method: 'POST',
          data: {
            code: '100003'  // 采购计划审批流程的 code
          }
        })

        if (response.data) {
          // 将接口返回的数据转换为选项格式
          this.workFlowOptions = response.data.map(item => ({
            value: item.processId,
            label: item.processName
          }))
        } else {
          this.workFlowOptions = []
          this.$message.warning('暂无可用的工作流')
        }
      } catch (error) {
        console.error('获取工作流数据失败:', error)
        this.$message.error('获取工作流数据失败')
        this.workFlowOptions = []
      }
    },
    async fetchDepartmentList() {
      try {
        const res = await request({
          url: '/api/v1/dept/list',
          method: 'POST',
          data: {
            name: '',
            status: -1
          }
        })

        if (res && res.data) {
          // 格式化部门数据为树形结构
          this.departmentList = this.formatDepartmentData(res.data)
          console.log('部门树形数据:', this.departmentList)
        }
      } catch (error) {
        console.error('获取部门列表错误:', error)
        this.$message.error('获取部门列表失败')
      }
    },
    formatDepartmentData(list) {
      // 递归处理部门数据
      const buildTree = (items, parentId = '0') => {
        return items
          .filter(item => item.parent_id === parentId)
          .map(item => ({
            id: item.dept_id,
            value: item.dept_id,
            label: item.dept_name,
            children: buildTree(items, item.dept_id)
          }))
          .sort((a, b) => a.label.localeCompare(b.label)) // 按部门名称排序
      }

      // 返回构建好的树形结构
      return buildTree(list)
    },
    //
    async getCategoryOptions() {
      try {
        const response = await request({
          url: '/api/v1/dict/type',
          method: 'POST',
          data: {
            dictType: 'CGLM',
            dictItemName: ''
          }
        })

        console.log('分类数据:', response)

        if (response.data) {
          this.categoryOptions = response.data.map(item => ({
            value: item.itemValue,
            label: item.itemLabel
          }))
        } else {
          this.categoryOptions = []
          this.$message.warning('暂无可用的分类')
        }
      } catch (error) {
        console.error('获取分类数据失败:', error)
        this.$message.error('获取分类数据失败')
        this.categoryOptions = []
      }
    },
    handleDepartmentChange(value) {
      console.log('选中的部门路径:', value)
      // 保存最后一个选中的部门ID
      this.temp.department = Array.isArray(value) ? value[value.length - 1] : value
    },
    handleSubmit(row) {
      // 检查状态是否为草稿(1)或已拒绝(5)
      if (row.status !== 1 && row.status !== 5) {
        this.$message.error('当前状态不允许提交')
        return
      }

      this.$confirm(row.status === 1 ? '确认提交该采购计划?' : '确认重新提交该采购计划?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/api/v1/purchasing-plan/submit',
          method: 'POST',
          data: {
            planId: row.planId,
            status: 2  // 提交后状态变为待审核
          }
        }).then(response => {
          if (response.status === 1) {
            this.$message({
              type: 'success',
              message: row.status === 1 ? '提交成功' : '重新提交成功'
            })
            this.getList() // 刷新列表
          } else {
            this.$message.error(response.msg || '提交失败')
          }
        }).catch(error => {
          console.error('提交失败:', error)
          this.$message.error(error.response?.data?.msg || '提交失败')
        })
      })
    },
    handleCancel(row) {
      this.$prompt('请输入取消原因', '取消原因', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        inputType: 'textarea',
        inputPlaceholder: '请输入取消原因'
      }).then(({ value }) => {
        request({
          url: '/api/v1/purchasing-plan/cancel',
          method: 'POST',
          data: {
            planId: row.planId,
            reason: value || ''  // 添加取消原因
          }
        }).then(response => {
          if (response.status === 1) {
            this.$message({
              type: 'success',
              message: '取消成功'
            })
            this.getList() // 刷新列表
          } else {
            this.$message.error(response.msg || '取消失败')
          }
        }).catch(error => {
          console.error('取消失败:', error)
          this.$message.error('取消失败')
        })
      })
    },
    handleApprove(row) {
      this.$confirm('', '审核采购计划', {
        confirmButtonText: '通过',
        cancelButtonText: '驳回',
        type: 'warning',
        showClose: true,
        distinguishCancelAndClose: true,
        showInput: true,
        inputPlaceholder: '请输入审核意见',
        customClass: 'approve-dialog',
        beforeClose: (action, instance, done) => {
          if (action === 'close') {
            // 点击右上角关闭按钮
            done()
            return
          }

          if (!instance.inputValue) {
            this.$message.warning('请输入审核意见')
            return
          }

          if (action === 'confirm') {
            // 点击"通过"按钮
            request({
              url: '/api/v1/purchasing-plan/approve',
              method: 'POST',
              data: {
                planId: row.planId,        // 采购计划ID
                approved: 2,               // 审核结果：2-同意
                comment: instance.inputValue // 审批意见
              }
            }).then(response => {
              if (response.status === 1) {
                this.$message.success('审核通过')
                this.getList()
                done()
              }else {
                if(response.status === 0){
                  this.$message.error(response.msg || '你不是当前审批人')
                }
              }
            })
          } else if (action === 'cancel') {
            // 点击"驳回"按钮
            request({
              url: '/api/v1/purchasing-plan/approve',
              method: 'POST',
              data: {
                planId: row.planId,        // 采购计划ID
                approved: 1,               // 审核结果：1-拒绝
                comment: instance.inputValue // 审批意见
              }
            }).then(response => {
              if (response.status === 1) {
                this.$message.success('已驳回')
                this.getList()
                done()
              }
            }).catch(() => {
              this.$message.error('操作失败')
            })
          }
        }
      }).then(() => {
        // 处理已经在 beforeClose 中完成
      }).catch(() => {
        // 取消操作，不做任何处理
      })
    },
    formatDateTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      if (isNaN(d.getTime())) return '-'
      
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      const second = String(d.getSeconds()).padStart(2, '0')
      
      return `${year}/${month}/${day} ${hour}:${minute}:${second}`
    },
    getTimelineNodeType(status) {
      switch (status) {
        case 2: return 'success'  // 已完成
        case 1: return 'primary'  // 进行中
        case 0: return 'info'     // 未开始
        case 3: return 'danger'   // 已拒绝
        case 4: return 'warning'  // 已取消
        default: return 'info'
      }
    },
    getApproverStatusText(status) {
      // 将 status 转换为数字类型，以确保正确匹配
      const statusNum = Number(status);

      const statusMap = {
        0: '未处理',
        1: '处理中',
        2: '已拒绝',
        3: '已通过',
        4: '已转交',
        5: '已回退'
      }

      // 添加调试日志
      console.log('Approver status:', status, 'Mapped status:', statusMap[statusNum]);

      return statusMap[statusNum] || '未知状态';
    },
    getStatusTagType(status) {
      const typeMap = {
        0: 'info',    // 未处理
        1: 'warning', // 处理中
        2: 'danger',  // 已拒绝
        3: 'success', // 已通过
        4: 'info',    // 已转交
        5: 'warning'  // 已回退
      }
      return typeMap[status] || 'info'
    },
    handleCommand(command, row) {
      switch (command) {
        case 'edit':
          this.handleUpdate(row)
          break
        case 'detail':
          this.handleDetail(row)
          break
        case 'submit':
          this.handleSubmit(row)
          break
        case 'approve':
          this.handleApprove(row)
          break
        case 'cancel':
          this.handleCancel(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'createOrder':
          this.handleCreateOrder(row)
          break
        case 'resubmit':
          this.handleSubmit(row)
          break
        case 'revoke':
          this.handleCancel(row)
          break
      }
    }
  },
  filters: {
    formatDate(timestamp) {
      return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}

</script>

<style lang="scss" scoped>
/* 添加待审批状态样式 */
.pending-status {
  color: #f56c6c !important;
  border-color: #f56c6c !important;
  background-color: #fef0f0 !important;

  &:hover {
    opacity: 0.8;
  }
}

.app-container {
  padding: 20px;

  .filter-container {
    padding-bottom: 10px;

    .filter-item {
      vertical-align: middle;
    }
  }

  .el-button {
    &+.el-button {
      margin-left: 5px;
    }
  }

  .el-table {
    .el-tag {
      margin: 2px 0;
    }

    .el-button {
      padding: 7px 12px;
    }
  }

  .timeline-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-weight: bold;
  }

  .timeline-content {
    color: #666;
    font-size: 13px;
    line-height: 1.5;
  }

  .el-tag {
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .workflow-btn {
    display: inline-flex;
    align-items: center;
    color: #409EFF;

    &:hover {
      color: #66b1ff;

      .el-icon--right {
        transform: scale(1.2);
      }
    }

    .el-icon--right {
      margin-left: 5px;
      transition: transform 0.3s ease;
    }
  }
}

.dealer-manage {

  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    padding: 0;
  }

  .filter-container {
    padding-bottom: 10px;
  }

  .operation-container {
    margin-bottom: 20px;
  }

  .pagination-container {
    padding: 20px 0;
    text-align: right;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .upload-demo {
    margin-bottom: 20px;
  }

  .el-upload__tip {
    line-height: 1.2;
    margin-top: 5px;
    color: #909399;
  }
}

.flow-dialog {
  .flow-container {
    padding: 20px 10px;
  }

  ::v-deep .el-timeline {
    padding: 0 20px;

    .el-timeline-item {
      padding-bottom: 25px;

      &:last-child {
        padding-bottom: 0;
      }

      .el-timeline-item__node {
        &--large {
          width: 14px;
          height: 14px;
        }

        &.is-success {
          background-color: #67C23A;
        }

        &.is-warning {
          background-color: #E6A23C;
        }

        &.is-danger {
          background-color: #F56C6C;
        }
      }

      .el-timeline-item__wrapper {
        padding-left: 25px;
      }

      .el-timeline-item__timestamp {
        color: #909399;
        font-size: 13px;
        margin-bottom: 8px;
      }
    }
  }

  .flow-item {
    background: #f8f9fa;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 10px;

    .flow-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .flow-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;

        .step-tag {
          background: #ecf5ff;
          color: #409eff;
          padding: 2px 6px;
          border-radius: 4px;
          margin-right: 8px;
          font-size: 12px;
        }
      }
    }

    .flow-content {
      .flow-info {
        .info-header {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          color: #606266;

          i {
            margin-right: 5px;
          }
        }

        .approver-list {
          .approver-item {
            padding: 10px 0;
            border-bottom: 1px dashed #ebeef5;

            &:last-child {
              border-bottom: none;
            }

            .approver-row {
              display: flex;
              align-items: center;
              gap: 12px;

              .approver-name {
                font-weight: 500;
                min-width: 80px;
              }

              .approve-time {
                color: #909399;
                font-size: 12px;
              }
            }

            .approve-comment {
              margin-top: 8px;
              padding-left: 2px;
              color: #606266;
              font-size: 13px;

              i {
                margin-right: 5px;
                color: #909399;
              }
            }
          }
        }

        .no-approver {
          color: #909399;
          font-size: 13px;
        }
      }
    }
  }
}

::v-deep .el-timeline-item__node {
  &.is-success {
    background-color: #67C23A;
  }

  &.is-warning {
    background-color: #E6A23C;
  }

  &.is-danger {
    background-color: #F56C6C;
  }
}

.form-section {
  margin-bottom: 20px;

  .section-title {
    font-size: 15px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 20px;
    padding-left: 10px;
    border-left: 3px solid #409EFF;
  }
}

::v-deep .el-input-number {
  width: 100%;
}

::v-deep .el-rate {
  height: 40px;
  line-height: 40px;

  .el-rate__text {
    margin-left: 10px;
    font-size: 14px;
  }
}

::v-deep .el-input-group__prepend {
  background-color: #f5f7fa;
  color: #909399;
  width: 40px;
}

::v-deep .el-textarea__inner {
  font-family: inherit;
}

.operation-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px;
  padding: 5px 0;

  .el-button {
    margin: 0;
    min-width: 76px;
  }
}

.approve-dialog {
  .el-message-box__header {
    padding: 15px 20px;
    border-bottom: 1px solid #ebeef5;

    .el-message-box__title {
      font-size: 16px;
      font-weight: 500;
    }

    .el-message-box__headerbtn {
      top: 15px;
      right: 20px;

      &:hover .el-message-box__close {
        color: #409EFF;
      }
    }
  }

  .el-message-box__content {
    padding: 20px;

    .el-message-box__input {
      padding-top: 15px;

      .el-input__inner {
        height: 80px;
        padding: 5px 10px;
        font-size: 14px;
        resize: none;
      }
    }
  }

  .el-message-box__btns {
    padding: 10px 20px 20px;
    text-align: right;

    .el-button {
      padding: 9px 20px;

      &+.el-button {
        margin-left: 10px;
      }
    }
  }
}

.flow-item {
  .flow-header {
    .step-tag {
      background-color: #f0f2f5;
      padding: 2px 6px;
      border-radius: 4px;
      margin-right: 8px;
      font-size: 12px;
      color: #606266;
    }

    .flow-title {
      display: flex;
      align-items: center;

      span+span {
        margin-left: 4px;
        color: #909399;
        font-size: 13px;
      }
    }
  }
}

.flow-content {
  .flow-info {
    .approver-list {
      margin-left: 5px;

      .approver-item {
        border-bottom: 1px dashed #DCDFE6;
        padding: 8px 0;

        &:last-child {
          border-bottom: none;
        }

        .approver-row {
          display: flex;
          align-items: center;
          gap: 12px;

          .approver-name {
            font-size: 13px;
            font-weight: 500;
            color: #303133;
            min-width: 80px;
          }

          .el-tag {
            height: 22px;
            line-height: 20px;
            padding: 0 8px;
            font-size: 12px;
            min-width: 64px;
            text-align: center;
          }

          .approve-comment {
            flex: 1;
            color: #606266;
            font-size: 13px;
            padding-left: 12px;
            margin: 0 12px;
            border-left: 2px solid #EBEEF5;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .approve-time {
            color: #909399;
            font-size: 12px;
            white-space: nowrap;
            min-width: 135px;
          }

          /* 添加待审批状态样式 */
          .approver-row {
            .el-tag {
              &.pending {
                color: #f56c6c;
                border-color: #f56c6c;
                background-color: #fef0f0;
              }
            }
          }
        }
      }
    }
  }
}

.el-dropdown {
  margin: 0 5px;
}

.el-dropdown-menu {
  .el-dropdown-item {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    
    i {
      margin-right: 8px;
      font-size: 16px;
    }
    
    &:hover {
      background-color: #ecf5ff;
      color: #409EFF;
    }
  }
}
</style>
